import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { UserMessagesService } from 'app/shared/user-messages/user-messages.service';

@Component({
  selector: 'app-nofshonim-admin-reservations',
  templateUrl: './nofshonim-admin-reservations.component.html',
  styleUrls: ['./nofshonim-admin-reservations.component.css']
})
export class NofshonimAdminReservationsComponent implements OnInit {

  constructor(private router: Router,
    private userMessagesService: UserMessagesService) { }

  ngOnInit() 
  {
    // Component to delete
  }
}
